"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithLink = void 0;
const hooks_1 = require("./hooks");
const WithLink = ({ to, params, query, className, render, children }) => {
    const renderFn = render || children;
    const { resolvePath, goTo, isActive } = (0, hooks_1.useRouterActions)();
    const onClickHandler = (e) => {
        if (to) {
            e.preventDefault();
            e.stopPropagation();
            if ((e.ctrlKey || e.metaKey) && typeof window !== 'undefined') {
                window.open(resolvePath(to, params || {}, query), '_blank');
                return;
            }
            goTo(to, params || {}, query);
        }
    };
    const link = {
        className,
        onClick: onClickHandler,
        href: resolvePath(to, params || {}, query)
    };
    if (!renderFn) {
        return null;
    }
    return renderFn({ link, isActive: isActive(to, params, query) });
};
exports.WithLink = WithLink;
//# sourceMappingURL=WithLink.js.map